<template>
    <div ref="kakaoMap" id="kakaoMap">
        <div class="mapMask"></div>
    </div>
</template>

<script>
    export default {
        name:'kakaoMap',
        props: {
            lat: Number,
            har: Number,
        },
        created () {},
        mounted () {
            this.setKakaoMap();
        },
        methods: {
            setKakaoMap() {
                var container = document.getElementById('kakaoMap'); //지도를 담을 영역의 DOM 레퍼런스
                var options = { //지도를 생성할 때 필요한 기본 옵션
                    // center: new kakao.maps.LatLng(33.45070, 126.57066), //지도의 중심좌표.
                    center: new window.kakao.maps.LatLng(this.lat, this.har), //지도의 중심좌표.
                    level: 3 //지도의 레벨(확대, 축소 정도)
                };

                var map = new window.kakao.maps.Map(container, options); //지도 생성 및 객체 리턴

                map.setDraggable(false);
                map.setZoomable(false);  

                // 마커가 표시될 위치입니다 
                var markerPosition  = new window.kakao.maps.LatLng(this.lat, this.har); 
                // var markerPosition  = new window.kakao.maps.LatLng(33.45070, 126.57066); 

                // 마커를 생성합니다
                var marker = new window.kakao.maps.Marker({
                    position: markerPosition
                });

                // 마커가 지도 위에 표시되도록 설정합니다
                marker.setMap(map);
            }
        },
    }
</script>

<style scoped>
/* .mapBack {
    position: relative;
} */

.mapMask {
    position:absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
}
</style>